'use client';

import { useGtmTrack } from '../index';
import { ANALYTICS_EVENTS } from '../types';
import type { LoginLinkTappedProps, TrackingFunction } from '../types';

export const useLoginLinkTracking = (props: LoginLinkTappedProps, autoTrack: boolean = false): TrackingFunction => {
  return useGtmTrack(
    {
      eventName: ANALYTICS_EVENTS.LOGIN_LINK_TAPPED,
      properties: props,
    },
    autoTrack,
  );
};
